export function openApp(path = "") {
  const userAgent = navigator.userAgent || navigator.vendor;

  const isAndroid = /android/i.test(userAgent);
  const isIOS = /iphone|ipad|ipod/i.test(userAgent);

  const deepLink = `zamilac://${path}`;

  const androidStore =
    "https://play.google.com/store/apps/details?id=com.zamilac.androidusers";

  const iosStore = "https://apps.apple.com/us/app/zamil-air-conditioners/id1662278739";

  // Desktop / unsupported device
  if (!isAndroid && !isIOS) {
    window.location.href = "/"; // or your web application
    return;
  }

  // Track whether the app was opened by listening for blur/visibility events
  // before triggering the deep link — by the time setTimeout fires, the state
  // may already be restored to "visible" even if the app did open.
  let appOpened = false;

  const onHidden = () => { appOpened = true; };
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") onHidden();
  });
  window.addEventListener("blur", onHidden);

  window.location.href = deepLink;

  setTimeout(() => {
    document.removeEventListener("visibilitychange", onHidden);
    window.removeEventListener("blur", onHidden);

    if (!appOpened) {
      window.location.href = isAndroid ? androidStore : iosStore;
    }
  }, 1500);
}
